import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';
import { ApiResponse, API_URL, getHeaders } from './_api-helpers';
import { UserModel } from 'models/User';

/**
 * Completes the application-side account setup for an authenticated Cognito user.
 * This is intentionally safe to retry: the backend treats an already-linked user
 * as a successful result.
 */
export async function linkNeveUser(emailAddress: string): Promise<void> {
    const { given_name: firstName = '', family_name: lastName = '' } = await fetchUserAttributes();
    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken?.toString();

    if (!token) throw new Error('No authenticated session available.');

    const response = await fetch(`${API_URL}/users/me`, {
        headers: getHeaders(token),
        method: 'POST',
        body: JSON.stringify({
            email: emailAddress,
            firstName,
            lastName,
        }),
    });

    const responseJson: ApiResponse<UserModel> = await response.json();
    if (!response.ok || responseJson.errors?.length) {
        throw new Error('Could not complete Neve account setup.');
    }
}
